import type { UserOrganization } from '@server/types/responseTypes'
import { create } from 'zustand'

interface OrganizationState {
  // --- data ---
  externalOrganizationId?: string
  organizations: UserOrganization[]
  organization?: UserOrganization

  // --- status flags ---
  isLoading: boolean
  error?: unknown
  isSwitching: boolean

  // --- actions ---
  setOrganization: (org: UserOrganization) => Promise<void>
  setActiveExternalOrganization: (
    externalOrganizationId: string,
  ) => Promise<void>
  setOrganizationState: (
    partial: Partial<
      Omit<
        OrganizationState,
        'setOrganizationState' | 'setOrganization' | 'addOrganization'
      >
    >,
  ) => void
}

export const useOrganizationStore = create<OrganizationState>((set, get) => ({
  // initial state
  externalOrganizationId: undefined,
  organizations: [],
  organization: undefined,
  isLoading: false,
  error: undefined,
  isSwitching: false,

  setActiveExternalOrganization: async () => undefined,

  // switch to given org
  setOrganization: async (org) => {
    set({
      isSwitching: true,
      organization: org,
      externalOrganizationId: org.external_id,
    })
    await get().setActiveExternalOrganization(org.external_id)
    set({ isSwitching: false })
  },

  setOrganizationState: (partial) => set(partial),
}))
